import toast from "react-hot-toast";
import { getServerError } from "./misc";

export const onAPIError = (e) => {
  toast.error(getServerError(e));
};
